import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [ "daysList", "template", "isOpen", "isClosed" ]

  initialize() {
    if (this.data.get("opennow") == null) return;

    this.schedule = JSON.parse(this.data.get("schedule"));
    this.scheduleDays = JSON.parse(this.data.get("schedule_days"));
    this.currentDay = new Date().getDay();

    this.daysListTargets.forEach((item, index) => {
      if((this.currentDay == 0 && index == 6) || (this.currentDay == index + 1))
        item.classList.add("is-today")
    });

    let startAt = new Date(this.scheduleDays.find( day => day.weekday == this.currentDay).start_at);
    let pauseAt = new Date(this.scheduleDays.find( day => day.weekday == this.currentDay).pause_at || this.scheduleDays.find( day => day.weekday == this.currentDay).end_at);
    let restartAt = new Date(this.scheduleDays.find( day => day.weekday == this.currentDay).restart_at || this.scheduleDays.find( day => day.weekday == this.currentDay).start_at);
    let endAt = new Date(this.scheduleDays.find( day => day.weekday == this.currentDay).end_at);
    let openAllDay = this.scheduleDays.find( day => day.weekday == this.currentDay).open_all_day;

    if (
      this._isOpenToday() &&
      ( openAllDay ||
        this._isTimeInRange(startAt, pauseAt, new Date()) ||
        this._isTimeInRange(restartAt, endAt, new Date())
      )
    ) {
      this.isOpenTarget.classList.remove("hide");
    } else {
      this.isClosedTarget.classList.remove("hide");
    }

  }

  _isTimeInRange(start, end, t) {

    if (start.getHours() == t.getHours()) {
      return start.getMinutes() <= t.getMinutes();
    }

    if (end.getHours() == t.getHours()) {
      return end.getMinutes() >= t.getMinutes();
    }

    // after midnight
    if(end.getHours() < start.getHours()) {
      return start.getHours() < t.getHours() && (end.getHours() + 24) > t.getHours();
    }

    return start.getHours() < t.getHours() && end.getHours() > t.getHours();
  }

  _isOpenToday() {
    return !this.scheduleDays.find( day => day.weekday == this.currentDay).closed;
  }

}
